var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dropdown" }, [
    _c(
      "div",
      {
        staticClass: "dropdown-title",
        class: { shown: _vm.isShown },
        on: {
          click: function($event) {
            _vm.isShown = !_vm.isShown
          }
        }
      },
      [
        _c("div", { staticClass: "dropdown-arrow" }, [_vm._v("v")]),
        _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShown,
            expression: "isShown"
          }
        ],
        class: [
          "dropdown-container",
          _vm.containerClass,
          { right: _vm.title === "Ship" }
        ]
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }